import { useEffect, useState, type ReactNode } from "react";
import { NavLink } from "react-router-dom";
import AppHeader from "@/components/feature/AppHeader";
import BottomNav from "@/components/feature/BottomNav";
import { fetchCurrentProfile } from "@/services/auth";

const navItems = [
  { to: "/app/dashboard", label: "Inicio", icon: "ri-home-5-line" },
  { to: "/app/mi-ruta", label: "Mi Ruta", icon: "ri-route-line" },
  { to: "/app/cursos", label: "Cursos", icon: "ri-graduation-cap-line" },
  { to: "/app/guia-ia", label: "Guía IA", icon: "ri-robot-2-line" },
  { to: "/app/afiliado", label: "Afiliado", icon: "ri-team-line" },
  { to: "/app/mis-prospectos", label: "Prospectos", icon: "ri-user-search-line" },
  { to: "/app/mi-link", label: "Mi Link / QR", icon: "ri-qr-code-line" },
  { to: "/app/webinar", label: "Webinar", icon: "ri-live-line" },
  { to: "/app/lider", label: "Líder", icon: "ri-vip-crown-2-line" },
  { to: "/app/contactos", label: "Contactos", icon: "ri-contacts-book-2-line" },
  { to: "/app/reuniones", label: "Reuniones", icon: "ri-calendar-event-line" },
  { to: "/app/comunidad", label: "Comunidad", icon: "ri-community-line" },
  { to: "/app/retos", label: "Retos", icon: "ri-trophy-line" },
];

/**
 * Layout del Panel de Afiliado: barra lateral oscura en escritorio (como en el
 * diseño) y la navegación inferior de la app en móvil.
 */
export default function AffiliateShell({ children }: { children: ReactNode }) {
  const [isAdmin, setIsAdmin] = useState(false);
  useEffect(() => {
    let active = true;
    fetchCurrentProfile().then((p) => {
      if (active) setIsAdmin(p?.role === "admin");
    });
    return () => {
      active = false;
    };
  }, []);

  const items = isAdmin ? [...navItems, { to: "/app/admin", label: "Admin", icon: "ri-settings-3-line" }] : navItems;

  return (
    <div className="min-h-screen flex flex-col bg-[#F8FAFC]">
      <AppHeader variant="onLight" />
      <div className="flex-1 flex w-full max-w-[1400px] mx-auto">
        <aside className="hidden lg:flex w-24 flex-shrink-0 flex-col items-stretch gap-1 bg-[#0B1F3A] py-5 px-2 min-h-[calc(100vh-5rem)]" aria-label="Navegación principal">
          {items.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                [
                  "flex flex-col items-center gap-1 rounded-xl py-3 text-[11px] font-medium cursor-pointer transition-colors",
                  isActive ? "bg-[#7C3AED]/30 text-white ring-1 ring-[#7C3AED]/60" : "text-slate-300 hover:bg-white/5 hover:text-white",
                ].join(" ")
              }
            >
              <i className={`${item.icon} text-xl`}></i>
              {item.label}
            </NavLink>
          ))}
        </aside>
        <main className="flex-1 min-w-0 px-4 md:px-8 py-6 pb-[calc(6rem+env(safe-area-inset-bottom))] lg:pb-10 vv-safe-x">{children}</main>
      </div>
      <div className="lg:hidden">
        <BottomNav />
      </div>
    </div>
  );
}
